export default __webpack_public_path__ + "static/media/470CD2EB-7599-49B6-9681-B1FF01104B82_1_102_o.418f4fce.jpeg";